module.exports = __webpack_public_path__ + "img/parent-unit.aa87f668.png";